import { TabContext as MUITabContext, type TabContextProps as MUITabContextProps } from "@mui/lab";
import { createContext, useContext } from "react";

export interface TabContextProps extends MUITabContextProps {
  nestedValue?: string;
}

const Context = createContext<string | null>(null);
if (import.meta.env.DEV) {
  Context.displayName = "NestedTabContext";
}

const TabContext = (props: TabContextProps) => {
  return (
    <Context.Provider value={props.nestedValue ?? null}>
      <MUITabContext value={props.value}>{props.children}</MUITabContext>
    </Context.Provider>
  );
};

export const useNestedTabContext = () => {
  return useContext(Context);
};

export default TabContext;
